import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChatErrorState } from '../../model';
import { LogService } from '@shared/services';
import { ChatsService } from '../../services/chats.service';
@Component({
  selector: 'chat-error-state',
  templateUrl: './chat-error-state.component.html',
  styleUrls: ['./chat-error-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class chatErrorStateComponent {
  @Input() errorType: ChatErrorState;
  logger: any;
  constructor(
    logService: LogService,
    private chatsService: ChatsService
  ) {
    this.logger = logService.scope('Chat-error-Component');
  }
  openNewChat() {
    this.chatsService.chatErrorState = null;
    this.chatsService.openChat();
  }
}
